export const tu360Movilidad = {
    title: 'Tu360Movilidad',
    url: 'https://tu360-dev.apps.ambientesbc.com/movilidad/',
    pressable: true,
    brandColor: '#00C389',
    categories: [
        {
            title: 'Comprar vender y alquilar',
            icon: 'car-sedan',
            actionButtonInfo: {
                title: 'Conocer más',
                type: 'button',
                url: 'https://movilidadtu360.bancolombia.com/',
                hostname: 'movilidadtu360.bancolombia.com/',
                delegated: 'marketplace',
            },
            listOptions: [
                {
                    title: 'Comprar',
                    options: [
                        {
                            title: 'Ayúdame a encontrar un vehículo',
                            url: 'https://tu360-dev.apps.ambientesbc.com/movilidad/definir-vehiculo',
                            hostname: 'tu360-dev.apps.ambientesbc.com/movilidad/',
                            delegated: 'movilidad',
                            isNew: false
                        },
                        {
                            title: 'Carros nuevos',
                            url: 'https://movilidadtu360.bancolombia.com/carros-nuevos',
                            hostname: 'movilidadtu360.bancolombia.com/',
                            delegated: 'marketplace',
                            isNew: false
                        },
                        {
                            title: 'Carros usados',
                            url: 'https://movilidadtu360.bancolombia.com/carros-usados',
                            hostname: 'movilidadtu360.bancolombia.com/',
                            delegated: 'marketplace',
                            isNew: false
                        },
                        {
                            title: 'Motos',
                            url: 'https://movilidadtu360.bancolombia.com/motos',
                            hostname: 'movilidadtu360.bancolombia.com/',
                            delegated: 'marketplace',
                            isNew: false
                        },
                        {
                            title: 'Bicicletas',
                            url: 'https://movilidadtu360.bancolombia.com/bicicletas',
                            hostname: 'movilidadtu360.bancolombia.com/',
                            delegated: 'marketplace',
                            isNew: false
                        }
                    ]
                },
                {
                    title: 'Vender',
                    options: [
                        {
                            title: 'Publicar carro',
                            url: 'https://tu360-dev.apps.ambientesbc.com/movilidad/vender-carro/onboarding',
                            hostname: 'tu360-dev.apps.ambientesbc.com/movilidad/',
                            delegated: 'movilidad',
                            isNew: false
                        }
                    ]
                },
                {
                    title: 'Alquilar',
                    options: [
                        {
                            title: 'Carros por días con Localiza',
                            url: 'https://tu360-dev.apps.ambientesbc.com/movilidad/home-localiza',
                            hostname: 'tu360-dev.apps.ambientesbc.com/movilidad/',
                            delegated: '',
                            isNew: false
                        },
                        {
                            title: 'Carros desde 48 meses con Renting',
                            url: 'https://tu360-dev.apps.ambientesbc.com/movilidad/arrendar-carro',
                            hostname: 'tu360-dev.apps.ambientesbc.com/movilidad/',
                            delegated: '',
                            isNew: false
                        }
                    ]
                },
            ]
        },
        {
            title: 'Crédito para vehículo',
            icon: 'hand-holding-cash',
            actionButtonInfo: {
                title: 'Conocer más',
                type: 'button',
                url: 'https://tu360-dev.apps.ambientesbc.com/movilidad/financiar',
                hostname: 'tu360-dev.apps.ambientesbc.com/movilidad/',
                delegated: '',
                isNew: false
            },
            listOptions: [
                {
                    title: '¿No sabes por donde empezar?',
                    options: [
                        {
                            title: 'Simular crédito',
                            url: 'https://tu360-dev.apps.ambientesbc.com/movilidad/simulacion?type=credito',
                            hostname: 'tu360-dev.apps.ambientesbc.com/movilidad/',
                            delegated: '',
                            isNew: false
                        },
                    ]
                },
                {
                    title: 'Elegir opción',
                    options: [
                        {
                            title: 'Solicitar crédito para carro',
                            url: 'https://tu360-dev.apps.ambientesbc.com/movilidad/solicitar-credito/credenciales?vehicleType=carro',
                            hostname: 'tu360-dev.apps.ambientesbc.com/movilidad/',
                            delegated: '',
                            isNew: false
                        },
                        {
                            title: 'Solicitar crédito para moto',
                            url: 'https://tu360-dev.apps.ambientesbc.com/movilidad/solicitar-credito/credenciales?vehicleType=moto',
                            hostname: 'tu360-dev.apps.ambientesbc.com/movilidad/',
                            delegated: '',
                            isNew: false
                        },
                        {
                            title: 'Compra de cartera',
                            url: 'https://tu360-dev.apps.ambientesbc.com/movilidad/compra-de-cartera',
                            hostname: 'tu360-dev.apps.ambientesbc.com/movilidad/',
                            delegated: '',
                            isNew: false
                        },
                    ]
                }
            ]
        },
        {
            title: 'Seguro para vehículo',
            icon: 'wrench',
            actionButtonInfo: {
                title: 'Conocer más',
                type: 'button',
                url: 'https://segurovehiculo.bancolombia.com/?utm_medium=link&utm_source=website&utm_campaign=tu360-pilar-page&utm_content=menu-movilidad',
                hostname: 'tu360-dev.apps.ambientesbc.com/movilidad/',
                delegated: 'movilidad',
                isNew: false
            },
            listOptions: [
                {
                    title: 'Cotizar',
                    options: [
                        {
                            title: 'Seguro todo riesgo',
                            url: 'https://segurovehiculo.bancolombia.com/?utm_medium=link&utm_source=website&utm_campaign=tu360-pilar-page&utm_content=menu-movilidad',
                            hostname: 'https://segurovehiculo.bancolombia.com/',
                            delegated: '',
                            isNew: false
                        }
                    ]
                }
            ]
        }
    ]
}